var plugin_rtlignore_default = {
  "alignLeft": "mn-9e",
  "textWrapNowrap": "YOy5Y",
  "alignRight": "q7gu-",
  "alignCenter": "ka8aO",
  "sizeFullWidth": "XIMHM",
  "renderedInTable": "J7xLS",
  "sizeOriginal": "UqrEd",
  "sizeContent": "w11HS",
  "sizeSmall": "hJ-aV",
  "sizeSmallCenter": "Wxj6U",
  "flex": "hcqq5",
  "atomic": "-v8zF",
  "embed": "npAaf",
  "horizontalScrollbar": "PQ8O7",
  "pluginContainerMobile": "M97Cu"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
